export const SET_REDIRECT_URL = "SET_REDIRECT_URL";

export interface LoginRedirectState {
  redirectUrl: string;
}

export interface SetRedirectUrlAction {
  type: typeof SET_REDIRECT_URL;
  payload: string;
}

export type LoginRedirectActionTypes = SetRedirectUrlAction;

export const initialState: LoginRedirectState = {
  redirectUrl: "",
};

// eslint-disable-next-line default-param-last
export default function loginRedirect(state = initialState, action: LoginRedirectActionTypes): LoginRedirectState {
  if (action.type === SET_REDIRECT_URL) {
    return {
      ...state,
      redirectUrl: action.payload,
    };
  }

  return state;
}
